import { Box, Card, CardContent, CardMedia, Grid, Typography } from "@mui/material";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

import { cardsData } from "src/utils/dataHomePage";

function PartnerLicenses() {
  return (
    <Grid item xs={12} md={10} sm={8} lg={12} sx={{ display: "flex", flexDirection: "column" }}>
      <Card
        sx={{
          border: `1px solid ${PureLightThemeCaaS.colors.alpha.orange[100]}`,
          boxShadow: "none",
          borderRadius: 0.5,
          backgroundColor: `${PureLightThemeCaaS.colors.alpha.grayBackgroundCard[100]}`,
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            borderBottom: `1px solid ${PureLightThemeCaaS.colors.alpha.orange[100]}`,
            p: 1.5,
          }}
        >
          <Typography variant="h4" fontFamily="Roboto, arial" fontSize="18px" color={PureLightThemeCaaS.colors.alpha.white[100]} textAlign="center">
            Partners
          </Typography>
        </Box>

        <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between", paddingBottom: "0px !important" }}>
          <Box display="flex" flexDirection="column" gap={2} sx={{ pt: 0, pb: 3, textAlign: "center" }}>
            <Typography variant="h6" fontFamily="Roboto, arial" fontSize="16px" color={PureLightThemeCaaS.colors.alpha.white[100]}>
              Check out our partners licenses, and pay as you use them
            </Typography>
          </Box>

          <Grid container spacing={2} pb={3} display="flex" justifyContent="center" alignItems="center">
            {cardsData.map((card) => (
              <Grid item xs={8} sm={6} md={3} lg={2} key={card.id}>
                <Card
                  sx={{
                    textAlign: "center",
                    backgroundColor: `${PureLightThemeCaaS.colors.alpha.grayBackgroundCard[100]}`,
                    border: `1px solid ${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                    borderRadius: 2,
                    p: 2,
                    color: PureLightThemeCaaS.colors.alpha.white[100],
                    boxShadow: 0,
                  }}
                >
                  <Typography variant="h6" fontFamily="Roboto, arial" fontSize="16px" fontWeight="bold" pb={1}>
                    {card.title}
                  </Typography>
                  <CardMedia component="img" image={card.img} alt="Logo" sx={{ height: 40, objectFit: "contain" }} />

                  <Typography variant="body2" fontFamily="Roboto, arial" fontSize="12px" fontWeight="bold" pt={1} sx={{ color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }}>
                    {card.description}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default PartnerLicenses;
